import * as Yup from 'yup';

Yup.addMethod(Yup.date, 'greaterThan', function testDateGreaterThan(fieldName) {
  return this.when(fieldName, (fieldValue, schema) =>
    fieldValue && !Number.isNaN(fieldValue.valueOf())
      ? schema.min(fieldValue, 'VALIDATION:GREATER_OR_EQUAL_THAN_INITIAL_ERROR')
      : schema
  );
});
